import {
  GuestWaiverDisplay,
  GuestMemberResult,
  GuestWaiverSubmitPayload,
} from '@/types/guestWaiver';

const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:3000/api';

class GuestWaiverService {
  async getWaiver(lId: string): Promise<GuestWaiverDisplay> {
    const res = await fetch(
      `${API_BASE}/guest-waivers/waiver?lId=${encodeURIComponent(lId)}`,
    );
    if (!res.ok) {
      throw new Error(`Failed to load waiver: ${res.status}`);
    }
    return res.json();
  }

  async searchMembers(lId: string, q: string): Promise<GuestMemberResult[]> {
    const res = await fetch(
      `${API_BASE}/guest-waivers/members?lId=${encodeURIComponent(lId)}&q=${encodeURIComponent(q)}`,
    );
    if (!res.ok) {
      throw new Error(`Failed to search members: ${res.status}`);
    }
    return res.json();
  }

  async submitWaiver(payload: GuestWaiverSubmitPayload): Promise<void> {
    const res = await fetch(`${API_BASE}/guest-waivers`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    if (!res.ok) {
      const data = await res.json().catch(() => ({}));
      throw new Error(
        (data as { message?: string }).message || 'Failed to submit waiver',
      );
    }
  }
}

export const guestWaiverService = new GuestWaiverService();
export { GuestWaiverService };
